/* eslint-disable react-hooks/exhaustive-deps */
//import { useState } from "react";
import { Form, Input, Button, notification } from 'antd';

import AuthService from '../../../services/Auth.service';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IconForgotPassword2 from '../changepassword/IconForgotPassword2';
import InvalidPage from '../InvalidPage';
import ExpiredPage from '../ExpiredPage';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const authService = new AuthService();
export default function NewPasswordForm(props) {
    //const [loading, setLoading] = useState(false);
    //const [loginErr, setLoginErr] = useState({ status: false });
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();

    const messageError = [
        t('passwordPage.ruleTitle'),
        `- ${t('passwordPage.rule1')}`,
        `- ${t('passwordPage.rule2')}`,
        `- ${t('passwordPage.rule3')}`,
        `- ${t('passwordPage.rule4')}`,
    ];

    const strongRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~=!@#$%^&*()_+\-]).{8,}$/;
    const thaiRegex = /^(?=.*[ก-๏])/;

    const [statusToken, setStatusToken] = useState('ACTIVE');

    // console.log(statusToken)

    const { id } = useParams();

    const checkToken = () => {
        authService
            .checkToken(id)
            .then((response) => {
                setStatusToken(response.data.resultData.linkStatus);
            })
            .catch(async (err) => {
                console.log('ERR', err);
                if (err.response.status === 401) {
                    if (await authService.refreshToken()) {
                        return this.getChargerManagement();
                    }
                }
                notification['error']({
                    message: t('passwordPage.SomethingWentWrong'),
                    description: t('passwordPage.PleaseContactWebAdmin'),
                });
            });
    };

    const onFinish = async (values) => {
        //setLoading(true);
        await authService
            .newPassword(values.newPassword, values.conPassword, id)
            .then(async (response) => {
                if (response.data.resultMsg === 'SUCCESS') {
                    props.setCurrentPageAction({
                        name: 'SUSSCRESS',
                        mail: '',
                        text: 'RESETPASSWORD',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                if (err?.response)
                    if (err?.response?.status) {
                        notification['error']({
                            message: t('passwordPage.SomethingWentWrong'),
                            description: t(
                                'passwordPage.PleaseContactWebAdmin'
                            ),
                        });
                    } else {
                        notification['error']({
                            message: t('passwordPage.LoginFail'),
                            description: t(
                                'passwordPage.UsernameOtPasswordNotCorrect'
                            ),
                        });
                    }
            });
    };

    useEffect(() => {
        checkToken();
        try {
            if (localStorage.getItem('Remember') === 'true') {
                form.setFieldsValue({
                    username: localStorage.getItem('username'),
                    password: localStorage.getItem('password'),
                });
            }
            localStorage.removeItem('Remember');
        } catch (err) {
            console.log(err);
        }
    }, []);

    if (statusToken === 'ACTIVE')
        return (
            <>
                <div className="absolute top-8 right-10 text-sm z-30">
                    <button
                        className={classNames('cursor-pointer mx-2', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'th',
                        })}
                        onClick={() => i18n.changeLanguage('th')}
                    >
                        TH
                    </button>
                    |
                    <button
                        className={classNames('cursor-pointer  mx-2 ', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'en',
                        })}
                        onClick={() => i18n.changeLanguage('en')}
                    >
                        EN
                    </button>
                </div>
                <div className="justify-center px-12">
                    <div className="text-4xl mt-16 mb-2 text-center">
                        <IconForgotPassword2 />
                    </div>
                    <div className="text-3xl mb-4 font-semibold">
                        <span>{t('passwordPage.SetNewPassword')}</span>
                    </div>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        //requiredMark={'optional'}
                    >
                        <p>{t('passwordPage.ResetDescription')}</p>
                        <Form.Item
                            hasFeedback
                            name="newPassword"
                            label={
                                <span className="text-sm">
                                    {t('passwordPage.NewPassword')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'passwordPage.NewPasswordIsRequired'
                                    ),
                                },
                                () => ({
                                    validator(_, value) {
                                        if (thaiRegex.test(value)) {
                                            return Promise.reject(messageError);
                                        } else if (value.length < 8) {
                                            return Promise.reject(messageError);
                                        } else if (strongRegex.test(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(messageError);
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                className="rounded-lg"
                                size="large"
                                placeholder={t('passwordPage.NewPassword')}
                            />
                        </Form.Item>
                        <Form.Item
                            hasFeedback
                            name="conPassword"
                            label={
                                <span className="text-sm">
                                    {t('passwordPage.ConfirmNewPassword')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'passwordPage.ConfirmPasswordIsRequired'
                                    ),
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue('newPassword') ===
                                                value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                t('errorText.validateConfirm')
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                className="rounded-lg"
                                size="large"
                                placeholder={t(
                                    'passwordPage.ConfirmNewPassword'
                                )}
                            />
                        </Form.Item>

                        <Form.Item className="mt-12">
                            <Button
                                type="primary"
                                className="px-12"
                                size="large"
                                htmlType="submit"
                            >
                                {t('common.Confirm')}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </>
        );
    else if (statusToken === 'USED') return <InvalidPage />;
    else if (statusToken === 'EXPIRED') return <ExpiredPage />;
    else return <InvalidPage />;
}
